import React, { useContext, useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@material-ui/core';
import { Language as LanguageIcon } from '@material-ui/icons';
import { ApplicationContext, AppContext } from '../../context/Contexts';

const LANGUAGES = [
  { code: 'ro', displayName: 'Română' },
  { code: 'en', displayName: 'English' },
  { code: 'nl', displayName: 'Dutch' },
  { code: 'pl', displayName: 'Polski' },
  { code: 'cz', displayName: 'Czech' },
  { code: 'sk', displayName: 'Slovenčina' },
  { code: 'fr', displayName: 'Français' }
];

const LanguageSelector: React.FC = () => {
  const context = useContext(ApplicationContext);
  const translatorService = (context as AppContext).translatorService;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const currentCode = translatorService.GetLanguage() || 'ro';
  const currentLang = LANGUAGES.find((l) => l.code === currentCode) || LANGUAGES[0];

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (code: string) => {
    translatorService.SetLanguage(code);
    localStorage.setItem('locale', code);
    handleClose();
    window.location.reload();
  };

  return (
    <Box position="absolute" top={16} right={16} zIndex={9999}>
      <Button
        onClick={handleClick}
        size="small"
        style={{
          textTransform: 'none',
          color: '#555',
          backgroundColor: 'rgba(255,255,255,0.85)',
          borderRadius: 20,
          padding: '4px 12px',
          minWidth: 'auto'
        }}
        startIcon={<LanguageIcon style={{ fontSize: 18 }} />}
      >
        {currentLang.displayName}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === currentCode}
            onClick={() => handleSelect(lang.code)}
          >
            <Typography variant="body2">{lang.displayName}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;
